import React from 'react';

/**
 * GarageServiceIcon Icon - Used in serviceSplit page
 */
export const GarageServiceIcon = (): JSX.Element => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="15" height="16" viewBox="0 0 15 16" fill="none">
      <path
        d="M13.8335 2.86L11.8782 5L10.0508 3L12.0061 0.86C11.5483 0.633 11.043 0.5 10.5076 0.5C8.48928 0.5 6.85286 2.291 6.85286 4.5C6.85286 5.052 6.9552 5.578 7.13976 6.057L0.457031 11.5L4.11179 15.5L9.08501 8.186C9.52267 8.388 10.0033 8.5 10.5076 8.5C12.526 8.5 14.1624 6.709 14.1624 4.5C14.1624 3.914 14.0409 3.361 13.8335 2.86Z"
        stroke="#212121"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export default GarageServiceIcon;
